import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  getAllQuotations
} from 'services/redux/sales/projectOnboarding/action';
import ViewQuotations from './viewQuotations';

const mapStateToProps = (state) => ({
  allQuotations: state.projectOnboardingReducer.allQuotations
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getAllQuotations
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ViewQuotations);
